import { defineComponent as _defineComponent } from 'vue'
import { computed as _computed } from 'vue';

import { TagDto } from '@/api';
import Vue, { ref, onBeforeMount } from 'vue';
import glossaryModule from '@/store/modules/business-glossary';
import { getModule } from 'vuex-module-decorators';
import store from '@/store';
import BusinessGlossaryDrawer from '@/components/business-glossary/business-glossary-drawer/Business-Glossary-Drawer.vue';
import SEllipsisToolTip from '@/components/SEllipsisTooltip/SEllipsisTooltip.vue';
import SIcon from '@/components/SIcon.vue';

interface TermProps {
  term: TagDto;
  noClickable?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Term',
  props: {
  term: null,
  noClickable: { type: Boolean, default: false }
},
  setup(__props) {

const props = __props;


let terms: glossaryModule;

const elevation = ref(0);

const style = _computed(() => (props.noClickable ? 'cursor: default;' : 'cursor: pointer;'));

const setSelectedTerm = async () => {
  if (!props.noClickable) {
    Vue.prototype.$rightDrawer.setTitle(props.term.name);
    Vue.prototype.$rightDrawer.setComponent(BusinessGlossaryDrawer);
    await Vue.prototype.$rightDrawer.openDrawer();
    terms.setSelectedTerm(props.term);
  }
};

onBeforeMount(() => {
  terms = getModule(glossaryModule, store);
});

return { __sfc: true,props, terms, elevation, style, setSelectedTerm, _computed, TagDto, Vue, ref, onBeforeMount, glossaryModule, getModule, store, BusinessGlossaryDrawer, SEllipsisToolTip, SIcon }
}

})